import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { metrics } from 'component-library/__styling/settings'

export const StyledArticleBreachNotification = styled('div')({
    marginTop: calcRem(metrics.thewest.textMargin / 2),
    width: '100%',
})
